<template>
  <v-row>
    <v-col
      xs="12"
      md="4"
    >
      <v-text-field
        outlined
        dense
        v-model="model.label"
        label="Option"
        placeholder="eg. Size, Color, Material"
        @keyup="changeLabel"
        :disabled="template.allowCustomLabel === false"
        hide-details
      />
    </v-col>
    <v-col
      xs="12"
      md="8"
    >
      <v-row
        v-if="!template.type"
        no-gutters
      >
        <v-col cols="12">
          <v-text-field
            outlined
            dense
            v-model="newValue"
            label="New Value"
            hint="Press `Enter` to submit new value"
            @keyup.enter="submitNewValue()"
            hide-details
          />
        </v-col>
      </v-row>

      <v-row
        v-if="template.type === 'dateRange'"
        no-gutters
      >
          <v-col cols="5">
            <v-menu
              v-if="template.type === 'dateRange'"
              v-model="dateRangeStartMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateRange.start"
                  label="Start date"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                />
              </template>

              <v-date-picker v-model="dateRange.start" @input="dateRangeStartMenu = false"></v-date-picker>
            </v-menu>

          </v-col>
          <v-col cols="5">
            <v-menu
              v-if="template.type === 'dateRange'"
              v-model="dateRangeEndMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dateRange.end"
                  label="End date"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker v-model="dateRange.end" @input="dateRangeEndMenu = false"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="2" class="text-right">
            <v-btn
              rounded
              outlined
              color="primary"
              @click="submitNewValue()"
            >
              <v-icon left>add</v-icon>

              add
            </v-btn>
          </v-col>
      </v-row>

      <v-row
        v-if="template.type === 'dayOfWeek'"
        no-gutters
      >
        <v-col cols="12">
          <v-select
            outlined
            dense
            v-model="model.values"
            :items="getDaysOfWeek()"
            item-text="label"
            item-value="id"
            multiple
            @change="onChangeValues"
            hide-details
          />
        </v-col>
      </v-row>

      <v-row
        v-if="template.type === 'startEndTime'"
        no-gutters
      >
        <v-col cols="5">
          <v-menu
            v-if="template.type === 'startEndTime'"
            ref="menuStart"
            v-model="startTimeMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="startEndTime.start"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="startEndTime.start"
                label="Start time"
                prepend-icon="access_time"
                readonly
                v-on="on"
              />
            </template>
            <v-time-picker
              v-if="startTimeMenu"
              v-model="startEndTime.start"
              full-width
              @click:minute="$refs.menuStart.save(startEndTime.start)"
            />
          </v-menu>

        </v-col>
        <v-col cols="5">
          <v-menu
            v-if="template.type === 'startEndTime'"
            ref="menuEnd"
            v-model="endTimeMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="startEndTime.end"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="startEndTime.end"
                label="End time"
                prepend-icon="access_time"
                readonly
                v-on="on"
              />
            </template>
            <v-time-picker
              v-if="endTimeMenu"
              v-model="startEndTime.end"
              full-width
              @click:minute="$refs.menuEnd.save(startEndTime.end)"
            />
          </v-menu>
        </v-col>
        <v-col cols="2" class="text-right">
          <v-btn
            rounded
            outlined
            color="primary"
            @click="submitNewValue()"
          >
            <v-icon left>add</v-icon>

            add
          </v-btn>
        </v-col>
      </v-row>

      <v-row
        v-if="template.type === 'weekOfYear'"
        no-gutters
      >
        <v-col cols="12">
          <v-select
            outlined
            dense
            v-model="model.values"
            :items="getWeeksOfYear()"
            item-text="label"
            item-value="id"
            multiple
            hide-details
            @change="onChangeValues"
          />
          <div class="text-right">
            <v-btn
              text
              rounded
              color="primary"
              x-small
              @click="selectAllWeeks()"
            >
              select all
            </v-btn>
          </div>

        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <template v-for="(value, valueIndex) in model.values">
            <v-chip
              class="ma-1"
              small
              close
              @click:close="removeValueByIndex(valueIndex)"
            >
              {{ getChipLabel(value) }}
            </v-chip>
          </template>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import { isEmpty, get } from 'lodash'
import moment from 'moment'
import { dayOfWeekParsed, weekOfYearParsed, dateRangeParsed } from "../../services/util.service"

export default {
  props: {
    option: {
      type: Object,
      default: () => ({})
    },
    template: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      newValue: '',
      model: {
        label: '',
        values: []
      },
      startTimeMenu: false,
      endTimeMenu: false,
      startEndTime: {
        start: null,
        end: null,
      },
      dateRangeStartMenu: false,
      dateRangeEndMenu: false,
      dateRange: {
        start: null,
        end: null
      }
    }
  },
  mounted() {
    if (!isEmpty(this.option)) {
      this.model = {
        label: this.option.label || '',
        values: this.option.values || []
      }
    }

    if (!isEmpty(this.template)) {
      this.model = {
        values: this.model.values || this.template.values, // model takes precident
        label: this.model.label || this.template.label, // when updating, real value should show
      }
    }
  },
  methods: {
    _isEmpty: (val) => isEmpty(val),
    _get: (val) => get(val),
    selectAllWeeks() {
      const allWeeks = Array(53).fill().map((v, i) => `${moment().year()}-${i + 1}`)
      this.onChangeValues(allWeeks)
    },
    getChipLabel(value) {
      if(this.template.type === 'dayOfWeek') {
        return get(dayOfWeekParsed(value), 'label', '')
      } else if (this.template.type === 'weekOfYear') {
        return get(weekOfYearParsed(value), 'label', '')
      } else if (this.template.type === 'dateRange'){
        return get(dateRangeParsed(value), 'label', '')
      } else {
        return value
      }
    },
    getDaysOfWeek() {
      if (this.model.id && Array.isArray(this.model.values)) {
        return this.model.values.map(v => dayOfWeekParsed(v))
      } else {
        return Array(7).fill().map((v, i) => dayOfWeekParsed(i))
      }
    },
    getWeeksOfYear() {
      if (this.model.id && Array.isArray(this.model.values)) {
        return this.model.values.map(v => weekOfYearParsed(v))
      } else {
        // 53 weeks for overhang? happened this year (2020)
        return Array(53).fill().map((v, i) => weekOfYearParsed(`${moment().year()}-${i + 1}`))
      }
    },
    onChangeValues(val) {
      let setValues = [ ...val ]
      const type = get(this.template, 'type')
      if (type === 'startEndTime') {
        console.log('setting', val)
      } else if (type === 'weekOfYear') {
        // just the last value needs modifying
      }

      this.model = {
        ...this.model,
        values: setValues
      }

      this.$emit('change-option', this.model)
    },
    getOptionLabel() {
      return get(this.template, 'allowCustom')
    },
    changeLabel() {
      this.$emit('change-option', this.model)
    },
    submitNewValue() {
      if (!this.model) {
        this.model = { label: '', values: [] }
      }

      let value = this.newValue

      // @todo move to component
      if (this.template.type === 'startEndTime') {
        value = `${this.startEndTime.start}-${this.startEndTime.end}`
        this.startEndTime.start = null
        this.startEndTime.end = null
      }

      // @todo move to component
      if (this.template.type === 'dateRange') {
        value = `${this.dateRange.start}--${this.dateRange.end}`
        this.dateRange.start = null
        this.dateRange.end = null
      }

      this.model.values.push(value)

      this.model = {
        label: this.model.label || '',
        values: this.model.values
      }

      this.newValue = ''
      this.$emit('change-option', this.model)
    },
    removeValueByIndex(index) {
      this.model.values.splice(index, 1)

      this.$emit('change-option', this.model)
    }
  }
}
</script>
